import { useCallback, useEffect, useState } from 'react';
import { firebaseService } from '../services/firebaseService';

interface PageViewParams {
  screen_name: string;  // Changed from page_title
  screen_class?: string;  // Added for Firebase Analytics
  page_location?: string;
}

export function useAnalytics() {
  const [isAvailable, setIsAvailable] = useState<boolean>(false);

  useEffect(() => {
    firebaseService.isAnalyticsAvailable().then(setIsAvailable);
  }, []);

  const trackPageView = useCallback(async (params: PageViewParams) => {
    await firebaseService.trackEvent('screen_view', params);  // Changed from page_view to screen_view
  }, []);

  const trackEvent = useCallback(async (eventName: string, params?: Record<string, string | number | boolean>) => {
    await firebaseService.trackEvent(eventName, params);
  }, []);

  return {
    isAvailable,
    trackPageView,
    trackEvent
  };
} 